
class TabBarController {
    constructor() {
        'ngInject';
    }

    selectTab(tab) {
        this.onTabSelected({tab})
    }
}

export const TabBarComponent = {
    name: 'tabBar',
    component: {
        template: `
        <div data-ng-class="tab === $ctrl.currentTab ? 'active' : 'inactive'" 
            class="tab-border-box" 
            data-ng-repeat="tab in $ctrl.tabNames" data-ng-click="$ctrl.selectTab(tab)">
            <div>
                <span>
                    {{tab}}
                </span>
            </div>
        </div> 
        `,
        controller: TabBarController,
        bindings: {
            tabNames: '<',
            currentTab: '<',
            onTabSelected: '&'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/tabBar.component.js